{
  "commons": {
    "incomplete": "Svar saknas",
    "requiredQuestion": "Obligatorisk",
    "completed": "Klar",
    "invalid": "Ogiltig",
    "saving": "Sparar",
    "uploading": "Laddar upp",
    "saved": "Sparat",
    "and": "och",
    "month": "månad",
    "month_other": "månader",
    "year": "år",
    "year_other": "år",
    "save": "Spara",
    "edit": "Ändra",
    "delete": "Radera",
    "viewFile": "Visa fil",
    "downloadFile": "Ladda ner fil",
    "downloadFileError": "Det gick inte att ladda ner filen. Försök igen.",
    "support": {
      "assignedToAdminUser": "<b>Frågor?</b><br/> Kontakta {{firstName}}: <a>{{mobilePhoneNumber}}</a>",
      "default": "<b>Frågor?</b><br/> Kontakta oss: <a>{{mobilePhoneNumber}}</a>",
      "contactUs": "Kontakta oss: "
    },
    "processSteps": {
      "improveLoanApplication": "Fyll i uppgifter & skicka in",
      "improveLoanApplicationSubheading": "{{ numAnswered }} av {{ numQuestions }} besvarade",
      "compareBids": "Välj mellan erbjudanden",
      "bidSelected": "Få finansiering utbetalt"
    },
    "app": {
      "title": {
        "loanAppForm": "Ansökan Företagslån",
        "factoringAppForm": "Ansökan Fakturaköp",
        "preliminaryBidForm": "Se företagets låneutrymme",
        "realEstateForm": "Ansökan Fastighetslån",
        "leasingForm": "Leasing application form",
        "improveApp": "Förbättra din ansökan",
        "dashboard": "Dashboard",
        "selectedLenderResponse": "Frågor från långivaren",
        "advice": "Råd",
        "application": "Ansök"
      }
    },
    "contactCustomerServiceDialog": {
      "support": "Support",
      "contactCustomerService": "Kontakta kundtjänst",
      "needHelp": "Behöver du hjälp?",
      "contactUs": "Kontakta vår kundservice.",
      "customerServiceOpen": "Öppet ",
      "customerServiceClosed": "Kundtjänst stängd",
      "customerServiceClosedMessage": "Kundtjänst stängd – ring oss {{openHours}} eller kontakta oss via e-post",
      "contactYourAdvisor": "Kontakta din rådgivare ({{advisorName}})",
      "bookMeetingWithAdvisor": "Boka ett möte med din rådgivare"
    }
  },
  "login": {
    "heading": "Logga in",
    "canceledTitle": "Avbruten",
    "startBankId": "Identifiera dig",
    "bankIdGeneric": "Mobilt BankID",
    "bankIdOnAnotherDevice": "BankID på annan enhet",
    "bankIdOnThisDevice": "BankID på denna enhet",
    "bankIdOnTestFlow": "Med SSN (Enbart för test)",
    "bankIdQrCodeManual": {
      "title": "Gör så här",
      "step1": "Starta appen Mobilt BankID",
      "step2": "Klicka på QR-ikonen i appen",
      "step3": "Rikta kameran mot QR-koden som visas här på skärmen",
      "step4": "Identifiera dig i appen"
    },
    "autostart": {
      "title": "Försöker starta BankID-appen",
      "description": "Om du inte har BankID-appen installerad på samma enhet som du befinner dig på, klicka då på 'BankID på annan enhet' här nedanför."
    },
    "writeSecurityCode": "Identifiera dig i appen",
    "giveValidSSN": "Ange ett giltigt personnummer.",
    "noApplicationForSSN": "Det finns ingen ansökan med angivet personnummer",
    "pleaseWait": "Var god vänta",
    "SSN": "Personnummer",
    "SSNHelper": "Personnummer används för att säkerställa att dina uppgifter skyddas från obehöriga",
    "continue": "Fortsätt",
    "loginCancelled": "Du har valt att avbryta din inloggning.",
    "loginError": "Inloggningen har avbrutits. Vänligen försök igen. Om du ändå upplever problem, kontakta Kundservice.",
    "abortLogin": "Avbryt inloggning",
    "back": "Tillbaka"
  },
  "errors": {
    "404": {
      "heading": "Sidan finns inte",
      "subheading": "Vi kunde tyvärr inte hitta sidan du letade efter.",
      "cta": {
        "user": "Tillbaka",
        "notUser": "Gå till startsidan"
      }
    },
    "fieldRequest": {
      "generic": "Något gick fel. Försök igen eller kontakta oss om problemet kvarstår."
    }
  },
  "openBankingData": {
    "isCompany": {
      "title": "Välj företagskonton i nästa steg",
      "cta": {
        "notOnboarded": "Dela kontoutdrag",
        "isOnboarded": "Dela ytterligare kontoutdrag"
      }
    },
    "connectBank": "Anslut din företagsbank",
    "clickToConnectBank": "Klicka nedan för att ansluta till din företagsbank",
    "successfullyConnected": "Ditt konto har anslutits",
    "shareBankStatement": "Dela kontoutdrag",
    "shareAnotherBankStatement": "Dela ytterligare ett kontoutdrag",
    "selectRevenueBank": "Välj den bank där företaget tar emot betalningar.",
    "showAllBanks": "Visa alla banker",
    "selectRevenueAccounts": "Välj de konton där du tar emot kundbetalningar",
    "confirmRevenueAccounts": "Bekräfta intäktskonton",
    "selectAtLeastOneAccount": "Välj minst ett konto",
    "isPrivate": {
      "optional": "Valfritt: ",
      "title": "Dela ditt kontoutdrag för att verifiera din inkomst.",
      "cta": "Dela utdrag från privatkonton"
    },
    "chooseBank": "Välj bank",
    "showMore": "Visa fler",
    "success": "Kontoutdrag har hämtats",
    "error": "Något gick fel. Försök igen eller kontakta kundservice",
    "selectionError": "Något gick fel. Säkerställ att din webläsare inte blockerade en popup/ny flik."
  },
  "slider": {
    "enterValueManually": "Ange värde",
    "backToSlider": "Tillbaka till slider"
  },
  "applicationForm": {
    "startOver": "Börja om",
    "testimonials": {
      "smallBusinessesTrustUs": "Småföretagare litar på oss",
      "saltoMarin": {
        "organization": "Saltö Marin AB",
        "type": "FASTIGHETSLÅN",
        "turnover": "OMSÄTTNING:",
        "loan": "LÅN:",
        "text": "Jag tycker det var ett bra sätt att jämföra olika villkor, speciellt nu när storbankerna inte är lika intresserade. Processen via Krea går betydligt snabbare och sparar tid jämfört med att gå direkt till banken.",
        "author": "Mats Lindqvist, VD"
      },
      "willBrand": {
        "organization": "Will Brand AB",
        "type": "HANDEL",
        "turnover": "OMSÄTTNING:",
        "loan": "LÅN:",
        "text": "Vi växer snabbare än vi räknat med och vår webshop för företag behövde ett upplyft samtidigt som vi behövde förskottsbetala produktionen av två stora höstprojekt. Hos Krea fungerar det överraskande snabbt och man får ett trevligt och bra bemötande av deras servicepersonal. Processen var betydligt smidigare i jämförelse med den gammalmodiga \"bankvärlden\".",
        "author": "Pierre Gasslander, VD"
      },
      "elfantminer": {
        "organization": "Elfantminer",
        "type": "PLATS: LOHJA",
        "turnover": "LÅNGIVARE: SME FINANCE",
        "loan": "LÅN:",
        "text": "Ansökan var lätt att göra och villkoren för de låneerbjudanden som kom in via Kredita var lätta att förstå. Under låneförhandlingarna fanns en känsla av att alla parter var genuint intresserade av företagets verksamhet och var redo att hitta en lösning som mötte företagets behov. Kreditas finansiella rådgivare höll hjulen rullande och pengarna fanns på kontot inom några veckor.",
        "author": "Kristian Savela, Grundare"
      }
    },
    "common": {
      "startApplicationHeading": "Få erbjudanden",
      "startApplicationSubheading": "Fyll i dina uppgifter",
      "customerCompanyLabel": "Kundföretag",
      "backToHome": "Tillbaka till startsidan",
      "getStarted": "Kom igång",
      "privacyPolicy": "integritetspolicy",
      "privacyPolicyConsent": "Jag godkänner att {{company}} behandlar mina <1>personuppgifter</1>",
      "businessNotFoundContactSupport": "Hittar du inte ditt företag? ",
      "applicationExists": "Det verkar som att du redan har en befintlig ansökan.",
      "loginToApplication": "Logga in på ansökan",
      "limitedCompanyConfirmation": "Aktiebolag",
      "customer": "Kunden",
      "partner": "Dig / samarbetspartner",
      "back": "Tillbaka",
      "continue": "Fortsätt",
      "kreaFullName": "Krea Technology AB",
      "kreditaFullName": "Kredita Oy",
      "kreaRegisteredBy": "är registrerat hos Finansinspektionen som annan finansiell verksamhet",
      "kreditaIsPartOf": "är en del av",
      "kreditaRegisteredBy": "som är hos Finansinspektionen som annan finansiell verksamhet",
      "anyQuestions": "Har du några frågor?",
      "happyToHelp": "Våra rådgivare hjälper dig gärna med alla finansieringsrelaterade frågor",
      "yourPersonalAdvisor": "Din personliga rådgivare: {{advisorName}}",
      "reachOutToYourAdvisor": "Hör av dig om du har frågor om din finansiering. Jag hjälper dig gärna!",
      "callUs": "Ring oss på",
      "primaryPurposeHeading": "Vad är det primära syftet med finansieringen?",
      "selectMainReason": "Om mer än ett syfte gäller, välj huvudsyftet",
      "buyOrLeaseAnAsset": "Inköp av bil eller maskin",
      "purchaseOfSupply": "Inköp av varulager",
      "expansion": "Expansion",
      "shortTermLiquidity": "Kortsiktig likviditet",
      "refinancing": "Refinansiering",
      "realEstate": "Fastighet",
      "invoiceFinance": "Factoring / sälja fakturor",
      "acquisitionFinance": "Förvärvslån",
      "otherReason": "Annat syfte",
      "realEstateSubheading": "Kan du specificera vad exakt finansieringen är för?",
      "bridgeFinancing": "Brygglån",
      "projectFinance": "Projektfinansiering",
      "purchaseNewProperty": "Köpa ny fastighet",
      "refinanceALoan": "Refinansiering",
      "renovationOfProperty": "Renovering av fastighet",
      "otherPropertyFinance": "Övrig fastighetsfinansiering",
      "realEstateExtendedHeading": "Vilken är fastighetsbeteckningen?",
      "invoiceFinanceSubheading": "Kan du ge mer information om dina försäljningsfakturor?",
      "totalInvoiceValue": "Totalt fakturavärde varje månad",
      "valuePlaceholder": "500 000",
      "invoicesAmountPlaceholder": "20",
      "invoicesSuffix": "fakturor",
      "numberOfInvoices": "Antal fakturor varje månad",
      "averagePaymentTime": "Genomsnittlig betaltid",
      "days": "dagar",
      "describeLargestInvoices": "Beskriv de tre största fakturorna du vill sälja eller belåna",
      "largestInvoicesPlaceholder": "Företagsnamn, bransch, månadsbelopp och typ av tjänst som säljs",
      "buyOrLeaseHeading": "Du valde inköp av bil, maskin eller utrustning",
      "buyOrLeaseSubheading": "Kan du ge lite mer information om ditt inköp?",
      "price": "Pris (exklusive moms)",
      "objectType": "Typ av objekt",
      "car": "Bil",
      "machine": "Maskin",
      "constructionMachine": "Byggmaskin",
      "restaurantEquipment": "Restaurangutrustning",
      "itOfficeEquipment": "IT/kontorsutrustning",
      "retailEquipment": "Detaljhandelsutrustning",
      "gymEquipment": "Gymutrustning",
      "truck": "Lastbil",
      "other": "Övrigt",
      "uploadOrLinkObject": "Ladda upp en offert eller lägg till en länk till objektet",
      "linkPlaceholder": "https://företag...",
      "offerOrLink": "Offert eller länk till objektet",
      "uploadFile": "Ladda upp fil",
      "linkToObject": "Länk till objekt",
      "financingAmountHeading": "Hur mycket finansiering är du i behov av?",
      "financingUpTo": "Finansiering upp till ",
      "notSureHowMuchToApplyFor": "Är du osäker på vilket belopp du ska ansöka om? ",
      "seeHowMuchYouQualifyFor": "Se ditt företags låneutrymme först.",
      "identificationHeading": "Identifiera dig",
      "weAreObligedToIdentifyYou": "Vi är enligt regelverk skyldiga att identifiera dig och verifiera din koppling till {{companyName}}.",
      "noApplicationOrCreditCheck": "Ingen ansökan eller kreditupplysning görs i detta steg.",
      "noApplication": "Ingen ansökan görs i detta steg",
      "acceptTermsAndConditions": "Genom att identifiera dig godkänner du <1>användarvillkoren</1>",
      "minimumFinancingAmountValidation": "Minsta belopp att ansöka om är {{amount}}"
    },
    "commons": {
      "heading": "Konkurrensutsätt 30 banker och långivare",
      "subHeading": "Det skapas ingen ansökan eller kreditupplysning i detta steg.",
      "requestedAmountPreLabel": "Önskad finansiering",
      "requestedAmountLabel": "Välj belopp",
      "exactRequestedAmountButton": "Ange exakt belopp",
      "exactRequestedAmountPlaceholder": "1 000 000",
      "exactRequestedPeriodButton": "Ange värde",
      "requestedAmountErrors": {
        "invalidAmount": "Välj belopp",
        "typeError": "Använd endast siffror",
        "required": "Välj belopp"
      },
      "reasonLabel": "Syfte",
      "reasonPlaceholder": "Välj syfte",
      "reasonLabelTooltip": "I nästa steg kommer du att kunna förklara ditt syfte mer i detalj och lägga till ytterligare information och säkerheter innan du väljer att skicka in din ansökan.",
      "reasonCategories": {
        "investments": "Investeringar",
        "working_capital": "Kassaflöde",
        "real_estate": "Fastighet",
        "real_estate_description": "Finansiering för fastighetsköp, refinansiering, renoveringar, brygglån och projektbaserade fastighetsinvesteringar.",
        "other": "Annat"
      },
      "reasons": {
        "object_financing": {
          "title": "Inköp av bil, maskin eller utrustning",
          "description": "Finansiera fordon, maskiner eller företagsutrustning."
        },
        "supply": {
          "title": "Inköp av varulager",
          "description": "Finansiera uppbyggnad eller utökning av varulager."
        },
        "expansion": {
          "title": "Expansion",
          "description": "Kapital för att växa företaget, anställa personal eller öppna nya enheter."
        },
        "short_term_liquidity": {
          "title": "Kortsiktig likviditet",
          "description": "Täck tillfälliga kassaflödesgap och löpande kostnader."
        },
        "refinancing": {
          "title": "Refinansiering",
          "description": "Ersätt eller konsolidera befintliga lån för förbättrade villkor."
        },
        "invoice_financing": {
          "title": "Factoring / sälja fakturor",
          "description": "Frigör kapital genom finansiering av utestående kundfakturor."
        },
        "acquisition_financing": {
          "title": "Förvärvslån",
          "description": "Finansiera förvärv av företag eller strategiska tillgångar."
        },
        "other": {
          "title": "Annat syfte",
          "description": "För finansieringsbehov som inte täcks av de listade alternativen."
        },
        "bridge_financing": {
          "title": "Bryggfinansiering",
          "description": "Tillfällig finansiering i väntan på långsiktig finansiering eller slutförd transaktion."
        },
        "project_financing": {
          "title": "Projektfinansiering",
          "description": "Finansiering av specifika projekt inom företaget."
        },
        "purchase_real_estate": {
          "title": "Köp av ny fastighet",
          "description": "Finansiera förvärv av kommersiella fastigheter eller lokaler."
        },
        "refinance_real_estate_loan": {
          "title": "Refinansiera fastighetslån",
          "description": "Förbättra villkoren eller frigör kapital från befintliga fastighetslån."
        },
        "renovation_of_property": {
          "title": "Renovering av fastighet",
          "description": "Finansiera byggnation, ombyggnad eller uppgraderingar av fastighet."
        },
        "other_property_finance": {
          "title": "Annan fastighetsfinansiering",
          "description": "För andra fastighetsrelaterade finansieringsbehov."
        },
        "property": "Fastighet",
        "machine": "Köp eller renovering av maskin",
        "consumables": "Löpande kostnader (t.ex. anställa, datorer, marknadsföring)",
        "capital": "Kapital under tiden kundfakturor betalas",
        "other_property": "Övrig fastighetsfinansiering",
        "project": "Projektfinansiering",
        "new_business": "Starta ny verksamhet",
        "restoration": "Renovering av fastighet eller lokal",
        "season_investment": "Säsongsinvestering / Kapital innan säsong kommer igång",
        "vehicle": "Köp eller renovering av fordon"
      },
      "reasonErrors": {
        "required": "Syfte krävs"
      },
      "companyNameLabel": "Ditt företag",
      "companyNamePlaceholder": {
        "SE": "Bolag AB eller XXXXXX-XXXX",
        "FI": "Bolag OY eller XXXXXXX-X"
      },
      "companyNameFindHelp": "Hittar inte ditt företag? Skriv ditt organisationsnummer.",
      "companyNameErrors": {
        "orgNumberRequired": "Organisationsnummer krävs",
        "orgNumberInvalid": "Ange ett giltigt organisationsnummer",
        "orgNameRequired": "Organisationsnamn krävs"
      },
      "companyNameChange": "Ändra",
      "companyNameSelect": "Välj",
      "companyNamePreloader": "Söker...",
      "emailLabel": "E-post",
      "emailPlaceholder": {
        "SE": "kontakt@bolag.se",
        "FI": "kontakt@bolag.fi"
      },
      "emailErrors": {
        "invalid": "Ogiltig e-post",
        "required": "E-post krävs",
        "alreadyExist": "Ange annan e-post",
        "validationError": "Vänligen ange en giltig e-postadress"
      },
      "ssnLabel": "Personnummer",
      "ssnPlaceholder": "YYYYMMDDXXXX",
      "ssnErrors": {
        "invalid": "Ogiltigt personnummer",
        "required": "Personnummer krävs"
      },
      "phoneLabel": "Mobilnummer",
      "phonePlaceholder": {
        "SE": "070 000 00 00",
        "FI": "050 0000 000"
      },
      "phoneErrors": {
        "invalid": "Mobilnumret är ogiltigt",
        "required": "Mobilnumret krävs",
        "incorrectLength": "Mobilnumret är för kort",
        "containsSpecialCharacters": "Mobilnumret kan endast innehålla siffror"
      },
      "consentCheckboxError": "Du behöver godkänna att vi behandlar dina personuppgifter för att använda tjänsten",
      "unpaidInvoicesValidation": {
        "unpaidInvoicesEstimatedRequired": "Önskat värde krävs",
        "unpaidInvoicesEstimatedInvalid": "Endast siffror",
        "numberOfUnpaidInvoicesRequired": "Ungefärligt antal krävs",
        "numberOfUnpaidInvoicesInvalid": "Endast siffror",
        "descriptionUnpaidInvoicesRequired": "Beskrivning av de 3 största fakturorna krävs"
      },
      "identifyCta": "Identifiera dig och fortsätt",
      "tosInfo": "Genom att identifiera dig godkänner du <1>användarvillkoren</1>",
      "loggedInFormCta": "Få erbjudanden"
    },
    "factoring": {
      "heading": "Få flera förslag på factoring",
      "subHeading": "Det skapas ingen ansökan eller kreditupplysning i detta steg."
    },
    "preliminaryBid": {
      "heading": "Få riktiga förslag"
    },
    "realEstate": {
      "heading": "Konkurrensutsätt flera banker och långivare",
      "subHeading": "Det skapas ingen ansökan eller kreditupplysning i detta steg.",
      "fields": {
        "propertyUnitDesignation": {
          "label": "Fastighetsbeteckning",
          "tooltip": "I nästa steg kommer du att kunna lägga till ytterligare information om fastigheten",
          "placeholder": "Fastighetsnamn 2:13",
          "errors": {
            "required": "Fastighetsbeteckning krävs"
          }
        }
      }
    },
    "leasing": {
      "heading": "Hitta rätt leasingavtal för ditt företag",
      "fields": {
        "objectType": {
          "label": {
            "appForm": "Typ av leasingobjekt",
            "fieldRequest": "Typ av objekt"
          },
          "placeholder": "Välj typ av objekt",
          "tooltip": "I nästa steg kommer du att kunna lägga till ytterligare information om leasingobjektet",
          "errors": {
            "required": "Leasingobjektet krävs"
          }
        },
        "objectDescription": {
          "label": "Beskrivning",
          "freetext": "Beskrivning kan inkludera: varumärke, leverantörens namn och skick (ny eller begagnad)"
        },
        "amount": {
          "label": "Pris på objektet (utan moms)",
          "placeholder": "450 000 {{currency}}",
          "errors": {
            "required": "Pris krävs"
          }
        },
        "offer": {
          "label": "Offert eller länk till objektet",
          "tabs": {
            "link": "Länk",
            "file": "Fil"
          },
          "links": {
            "link": {
              "label": {
                "appForm": "Länk till leasingobjektet",
                "fieldRequest": "Länk till det specifika objektet"
              },
              "placeholder": "https://company.se/mitt-leasing-objekt",
              "errors": {
                "empty": "Länk till leasingobjektet krävs",
                "notUrl": "Giltig URL krävs"
              }
            }
          },
          "errors": {
            "empty": "Lägg till information om leasing objektet"
          }
        }
      }
    },
    "formSwitcher": {
      "label": "Välj produkt",
      "companyLoanTab": "Företagslån",
      "factoringTab": "Factoring",
      "realEstateLoanTab": "Fastighetslån",
      "leasingTab": "Leasing"
    }
  },
  "iaq": {
    "whyImportantHeading": "Varför behöver banker och långivare denna information?",
    "questionsList": "Se alla frågor",
    "nextQuestionCta": "Nästa",
    "skipQuestionCta": "Hoppa över frågan",
    "previousQuestionCta": "Tillbaka",
    "reviewApplicationGoTo": "Nästa",
    "contactCustomerSupport": "Kontakta kundservice",
    "uploadedFiles": "Uppladdade filer",
    "save": "Spara",
    "edit": "Ändra",
    "add": "Lägg till",
    "close": "Klar",
    "cancel": "Avbryt",
    "progressBar": {
      "steps": "Fråga {{currentStep}} av {{stepsQty}}",
      "optional": "(Valfritt)"
    },
    "advice": {
      "digitalAdviceTitle": "Förbättra din ansökan",
      "digitalAdviceSubheading": "Vi har hittat möjliga förbättringar",
      "manualAdviceSubheading": "En av våra rådgivare kommer att kontakta dig inom en arbetsdag",
      "title": "Ditt företag kvalificerar sig för rådgivning",
      "titleDone": "Ditt företag kvalificerar sig för rådgivning",
      "doYouHaveQuestions": "Har du några frågor?",
      "applicationAttractiveness": "Attraktivitetsvärdet för din ansökan",
      "applicationAttractivenessComparableValueTooltip": {
        "paragraph1": "Din ansökans attraktivitetsvärde baseras på Kreas databas över tidigare kunder.",
        "paragraph2": "Vår bedömning baseras i huvudsak på bolagets kreditvärdighet och information om eventuella borgensmän.",
        "paragraph3": "Du kan förbättra ditt företags chanser att få bättre erbjudanden genom att lägga till mer information och säkerheter i din ansökan."
      },
      "applicationAttractivenessGrades": {
        "belowAverage": "Under genomsnittet",
        "average": "Bra",
        "excellent": "Väldigt bra"
      },
      "provideMoreDetailsWhileWaitingAdviceBypassDisabled": "Besvara minst en fråga om du vill skicka in utan rådgivning - alternativt, vänta och vi kontaktar dig inom en arbetsdag.",
      "provideMoreDetailsWhileWaiting": "Lägg till mer information medan du väntar på att bli kontaktad",
      "yourAdvisor": "Din rådgivare",
      "yourAdvisorIsHappyToAssist": "Din rådgivare hjälper gärna till",
      "improveApplicationWithImprovements": "Förbättra din ansökan genom att följa våra rekommendationer nedan.",
      "allImprovementsSolved": "Tack! Du följde våra rekommendationer och på så sätt borde du ha större chans att få bra erbjudanden.",
      "allImprovementsDismissed": {
        "title": "Du har valt att inte följa alla våra rekommendationer.",
        "subtitleDigitalAdvice": "Genom att välja \"Skicka in utan förbättringar\", kommer du få svar från långivarna inom kort.",
        "subtitleAdvice": "Din rådigvare kommer att kontakta dig inom en arbetsdag för att ytterligare förbättra din ansökan."
      },
      "whyIsScoreNot100%": "Varför är mitt resultat inte 100%?",
      "whyIsScoreNot100%Modal": {
        "paragraph1": "Din ansökans attraktivitetsvärde baseras på Kreas databas över tidigare kunder.",
        "paragraph2": "Vår uppskattning baseras till övervägande del på företagets kreditvärdighet, information om borgensmän och vilken information du har lagt till i ansökan.",
        "paragraph3": "Ditt resultat kanske inte når 100 % om din kreditvärdighet inte är stark eller om du nyligen har startat ditt företag."
      },
      "okButton": "OK",
      "actions": {
        "title": {
          "getAdvice": "Förbättra dina chanser genom rådgivning",
          "adviceWithout": "Vill du skicka in en ansökan utan rådgivning?"
        },
        "button": {
          "adviceCta": "Boka ett rådgivningsmöte",
          "adviceBack": "Tillbaka",
          "adviceWithout": "Skicka in utan rådgivning",
          "adviceDigital": "Visa förslag",
          "adviceDigitalWithoutChanges": "Skicka in utan förbättringar",
          "improveApplication": "Förbättra ansökan"
        }
      }
    },
    "guarantor": {
      "explanation": {
        "text": {
          "heading": "Välj möjliga borgensmän",
          "default": "Att ange borgensman i detta steg är inte bindande.",
          "soleTrader": "Som ägare av en enskild firma agerar du automatiskt som borgensman.",
          "partnership": "Ägare av en handelsbolag agerar automatiskt som borgensman."
        },
        "tooltip": "En borgensman har betalningsansvar i det fall företaget inte betalar tillbaka finansieringen. Att lägga till en borgensman är viktigt för att få så bra finansieringserbjudanden som möjligt.",
        "tooltipTrigger": "Vad är en borgensman?",
        "infoTextTitle": "Osäker på om du ska lägga till en borgensman nu?",
        "infoText": "Det är valfritt och kan läggas till senare i processen."
      },
      "me": "Mig själv",
      "addAnotherGuarantorQuestion": "",
      "addAnotherGuarantorOpen": {
        "empty": "Lägg till en annan borgensman",
        "notEmpty": "Lägg till en ytterligare borgensman"
      },
      "addContactDetails": "Lägg till kontaktuppgifter",
      "editContactDetails": "Ändra kontaktuppgifter",
      "addAnotherGuarantorClose": "Stäng",
      "personalNumberLabel": "Borgensmannens personnummer",
      "personalNumberPlaceholder": {
        "SE": "ÅÅÅÅMMDD-XXXX",
        "FI": "DDMMÅÅ-NNNT"
      },
      "personalNumberInvalid": "Ange ett giltigt personnummer",
      "emailLabel": "Borgensmannens e-post",
      "emailPlaceholder": "E-post",
      "emailInvalid": "Ange en giltig e-post",
      "phoneLabel": "Borgensmannens mobilnummer",
      "phonePlaceholder": "Mobilnummer",
      "phoneInvalid": "Ange ett giltigt mobilnummer",
      "boardMembers": "Styrelsemedlemmar",
      "boardMembersPlaceholder": "Välj styrelsemedlemmar",
      "boardMembersPersonalNumberMsg": "Vänligen ange personnummer på borgensman"
    },
    "reason": {
      "reasonExplanationTitle": "Beskriv syftet och berätta om er verksamhet",
      "otherReasonLabel": "Beskrivning",
      "freetext": "Kan inkludera: Hur du ska använda finansieringen och mer om din verksamhet."
    },
    "property": {
      "options": {
        "property_unit_designation": "Fastighetsbeteckning",
        "property_unit_designation_placeholder": "Fastighetsnamn 2:13",
        "property_current_mortgage": "Nuvarande belåning",
        "property_current_mortgage_placeholder": "Ex. \"Pantbrev på 2 miljoner finns\", \"Obelånad\"",
        "property_valuation_label": "Värde enligt senaste värdering",
        "property_valuation_label_with_purchase_real_estate": "Överenskommen köpeskilling",
        "property_valuation_placeholder": {
          "SE": "Ex. 5 000 000",
          "FI": "Ex. 500 000"
        },
        "property_additional_data_label": "Lägg till värdeutlåtande",
        "property_additional_data_label_with_purchase_real_estate": "Lägg till prospekt eller värdering",
        "property_additional_data_url_label": "Länk till fastigheten",
        "property_additional_data_url_placeholder": "https://link.se/fastighet"
      }
    },
    "propertyOwner": {
      "yes": "Ja",
      "no": "Nej"
    },
    "unpaidInvoices": {
      "about": {
        "newProduct": "Ny produkt",
        "heading": "Få erbjudanden om fakturaköp från flera banker och långivare kostnadsfritt",
        "paragraph": "Om ditt företag har försäljning genom fakturor kan du sälja fakturor och få upp till 99% av fakturavärdet utbetalt redan idag. Genom att svara på dessa frågor ser du vilket factoringbolag som ger bäst villkor för fakturaköp till ditt företag."
      },
      "invoiceValue": {
        "question": "Totalt fakturavärde varje månad",
        "placeholder": "500 000"
      },
      "numberOfInvoices": {
        "question": "Antalet fakturor varje månad",
        "previewValue": "{{count}} fakturor",
        "placeholder": "15"
      },
      "averagePaymentTimeDays": {
        "question": "Genomsnittligt förfallodatum",
        "choose": "Välj förfallodatum"
      },
      "accountsLedger": {
        "question": "Exempel på fakturor du vill sälja eller kundreskontra",
        "preview": "Ditt reskontra (senaste 12 månaderna)"
      },
      "invoicesDescription": {
        "question": "Obligatoriskt: Beskriv de 3 största fakturorna",
        "placeholder": "Vilken bransch, värdet och vad för tjänst eller produkt det avser",
        "preview": "Beskriv de 3 största fakturorna du vill sälja eller belåna"
      },
      "dueDateOptions": "{{days}} dagar"
    },
    "selfEstimatedHistoricRevenue": {
      "alertText": "Lägg till en uppskattning för tidsperioden",
      "infoText": "En uppskattning av din omsättning hjälper långivarna att ge dig relevanta erbjudanden.",
      "verifyRevenueTitle": "Vill du verifiera <span>omsättningen <helper /></span>",
      "automaticFetching": "Automatisk inhämtning",
      "helperText": "Du kan verifiera omsättningen genom Bokförings- eller Kontodata. Det är inte obligatoriskt, men kan leda till fler och bättre förslag.",
      "verify": "Verifiera",
      "verificationOptions": {
        "accountingFiles": {
          "title": "Ladda upp bokföring manuellt"
        },
        "bankingData": {
          "title": "Kontodata"
        }
      }
    },
    "amount": {
      "valuePlaceholder": "100 000"
    },
    "repaymentTime": {
      "valuePlaceholder": "12"
    },
    "accountingData": {
      "uploadManually": "Ladda upp manuellt",
      "delegateChoice": "Be kollega eller ekonomiansvarig lägga till",
      "upTo": "fram till",
      "accountingManually": {
        "periodText": "Obs. Lägg till bokföring fram till <span>{{to}} <helper /></span>",
        "helper": "Det är oftast tillräckligt att dela preliminära siffror. Långivaren vill helst förstå hur företagets resultat- och balansräkning har utvecklats efter senaste bokslut."
      },
      "uploadManuallyOption": "Övrigt / Vet ej",
      "uploadLater": "Ladda upp senare",
      "tabs": {
        "upload": "Ladda upp",
        "uploadPdf": "Ladda upp PDF",
        "uploadSie4": "Ladda upp SIE4",
        "invite": "Bjud in att ladda upp",
        "uploadLater": "Ladda upp senare",
        "sie4Description": "Exportera bokföringsdata i SIE4-format från ditt bokföringsprogram.",
        "sie4AcceptedFileTypes": "Ladda upp SIE4-filer (.se, .si, .sie) här",
        "sie4InvalidFileType": "Ladda upp en SIE4-fil (.se, .si eller .sie)."
      }
    },
    "transactionData": {
      "shareVia": "Dela ditt kontoutdrag enkelt och säkert via",
      "automaticFetching": "Automatisk inhämtning",
      "uploadManually": "Ladda upp kontoutdrag manuellt"
    },
    "fileUpload": {
      "uploadFilesCta": "Ladda upp fil",
      "acceptedFileTypesMessage": "Alla filtyper stöds"
    },
    "additionalSecurities": {
      "textareaPlaceholder": "Skriv här (valfritt)",
      "attachFiles": "Bifoga filer"
    },
    "leasing": {
      "preview": {
        "financingAmount": "Financing amount",
        "objectType": "Typ av objekt",
        "description": "Beskrivning av objekt",
        "amount": "{{amount}} (utan moms)",
        "offer": "Objekt"
      }
    },
    "isCollectedByLenderText": "Denna information hämtas av långivaren.",
    "refinancingAmounts": {
      "lenderLabel": "Långivare",
      "lenderPlaceholder": "Ex. Bank namn",
      "outstandingAmountLabel": "Utestående belopp",
      "outstandingAmountPlaceholder": "Ex. 250 000 {{currency}}",
      "monthlyCostLabel": "Månadsbetalning (amortering + lånekostnader)",
      "monthlyCostPlaceholder": "Ex. 50 000 {{currency}}",
      "addFirstOpen": "Lägg till ett befintligt lån",
      "addMoreOpen": "Lägg till ett annat lån",
      "addMoreClose": "Stäng",
      "attachmentText": "Bifoga låneavtal eller senaste månadsfaktura",
      "close": "Stäng",
      "save": "Spara"
    }
  },
  "advice": {
    "digital": {
      "heading": "Förbättra ansökan",
      "subheading": "Föreslagna förbättringar",
      "alertText": "Ansökan skickas automatiskt till långivare om 10 minuter",
      "submitText": "Skicka in ansökan direkt",
      "likelihood": "Sannolikhet att bli beviljad",
      "improvementsHeading": "Ange informationen nedan för att öka chansen att bli godkänd",
      "possibleImprovements": "Möjlig förbättring",
      "approvalChanceSummary": "Öka din chans att bli godkänd från {{current}}% till {{potential}}%",
      "potentialGain": "+{{gain}}%",
      "currentLikelihood": "Sannolikhet att få erbjudanden",
      "improvementPotential": "Förbättringspotential"
    },
    "revenue": {
      "title": "Lägg till senaste intäktsuppgifterna",
      "uploadAccountingData": "Ladda upp bokföring manuellt",
      "uploadBankingData": "Kontodata",
      "uploadBankingData2": "Automatisk insamling med BankID",
      "noData": "Jag har inga aktuella intäktsuppgifter att dela"
    },
    "manual": {
      "heading": "Du kvalificerar dig för vår rådgivningstjänst",
      "subheading": "Nästa steg för din ansökan",
      "yourAdvisor": "Din rådgivare",
      "advisorContactHint": "Om du har några frågor eller behöver hjälp, tveka inte att kontakta din rådgivare.",
      "advisorIntro": "Det är frivilligt att lämna informationen nedan. Den hjälper din rådgivare att få en bättre förståelse för ditt företag och att förbereda ett starkare finansieringsunderlag för din ansökan.",
      "whatIsAdvisory": {
        "title": "Vad är rådgivningstjänsten?",
        "description": "Vår Debt Advisory-tjänst riktar sig till företag som söker finansiering mellan {{minAmount}} och {{maxAmount}}. En dedikerad rådgivare driver hela finansieringsprocessen:",
        "list": {
          "item1": "Grundlig kreditanalys och bedömning av era finansieringsmöjligheter.",
          "item2": "Framtagande av ett omfattande kreditunderlag som tydligt beskriver verksamheten och dess potential för långivare.",
          "item3": "Strukturerad upphandling av långivare i konkurrens.",
          "item4": "Förhandling av villkor, deltagande i bankmöten och exekvering fram till utbetald finansiering."
        }
      },
      "whatHappensNext": "Vad händer härnäst?",
      "daysEndToEnd": "2–5 dagar från start till mål",
      "stepsList": {
        "step1": "Din rådgivare kontaktar dig",
        "step2": "Vi förbereder en kort affärsplan",
        "step3": "Vi delar den med relevanta långivare",
        "step4": "Du tar emot erbjudanden och väljer det bästa"
      },
      "footer": "Hela processen tar bara 2-5 dagar tills du får konkreta erbjudanden",
      "submitApplication": {
        "title": "Behöver du finansiering snabbare?",
        "cta": "Skicka in direkt"
      },
      "bookAdvisory": "Boka rådgivningsmöte"
    },
    "fieldRequests": {
      "heading": "Ytterligare information för rådgivaren (valfritt)",
      "subheading": "Dessa uppgifter hjälper oss att gå snabbare och skapa ett starkare case för dig.",
      "timeToFinancing": {
        "timeframeLabel": "När behöver du finansieringen?",
        "timeframePlaceholder": "Välj ett alternativ",
        "targetDateLabel": "Vilket datum?",
        "explanationLabel": "Vad driver tidsramen?",
        "explanationPlaceholder": "Beskriv din tidplan...",
        "helperText": "Att veta när du behöver finansieringen hjälper oss att prioritera långivare som kan möta din tidplan.",
        "choices": {
          "asap": "Så snart som möjligt",
          "within_1_month": "Inom 1 månad",
          "within_3_months": "Inom 3 månader",
          "no_specific_date": "Inget specifikt datum",
          "specific_date": "Specifikt datum"
        },
        "submit": "Spara"
      },
      "accountingData": {
        "helperText": "Aktuell ekonomisk information hjälper långivare och din rådgivare att bättre förstå ditt företag och hitta relevanta finansieringsalternativ.",
        "helperTextSIE4": "SIE4-filer är att föredra.",
        "helperTextPdf": "PDF-filer är att föredra."
      },
      "constructionEstimate": {
        "helperText": "Ladda upp en projektkalkyl som visar löpande kostnader."
      },
      "plPrognosis": {
        "helperText": "En prognos hjälper långivare att förstå ditt företag och dina planer framåt. Skapa en prognos, få hjälp av AI eller ladda upp en befintlig prognos.",
        "tableTitle": "P&L-prognos",
        "acquirerTab": "Förvärvande bolag",
        "targetTab": "Förvärvsobjekt",
        "draftTab": "Skapa resultatprognos",
        "uploadTab": "Ladda upp fil",
        "fileUploadLabel": "Ladda upp din resultatprognos",
        "aiAssist": {
          "open": "AI-assistent",
          "preparing": "Förbereder din P&L-assistent...",
          "startPromptLabel": "Starta P&L-prognos",
          "startPromptText": "Hjälp mig att bygga min resultatprognos.",
          "noAssistMode": "Klicka på AI-assistent-knappen i ett fält för att komma igång."
        },
        "standard": {
          "revenue_excl_vat": "Intäkter (exkl. moms)",
          "personnel_costs": "Personalkostnader",
          "other_costs": "Övriga kostnader",
          "ebitda": "EBITDA"
        },
        "real_estate": {
          "rental_income": "Hyresintäkter",
          "operating_costs": "Driftkostnader",
          "property_tax": "Fastighetsskatt",
          "net_operating_income": "Driftnetto"
        },
        "yearSuffix": {
          "actual": "utfall",
          "forecast": "prognos"
        },
        "notes": {
          "label": "Ytterligare information till rådgivaren",
          "placeholder": "Eventuella antaganden, kontext eller annan relevant information..."
        }
      }
    }
  },
  "dash": {
    "heading": "Dina finansieringserbjudanden är på väg",
    "headingBidsReceived": "Välj mellan förslag",
    "headingNoBidsReceived": "Du har inte fått några erbjudanden än så länge",
    "headingBidSelected": "Dina finansieringsförslag",
    "headingPaidOutOffers": "Utbetalda erbjudanden",
    "applicationHasBeenSent": "Din ansökan har skickats till långivare.",
    "biddingOpen": "Budgivning öppen ({{formattedLenderTimeLeft}} kvar)",
    "biddingClosed": "Budgivningstiden är slut",
    "offersValidFor": "Förslag är giltiga i {{daysLeft}} dagar",
    "offersValidForLessThanDay": "Förslag är giltiga i {{hoursLeft}} timmar",
    "biddingOpensSoon": "Ansökan är snart öppen för långivare",
    "applicationNotSubmitted": "Ansökan har inte skickats in",
    "rejectedMessage": "Kontakta kundtjänst om du vill ha hjälp med din ansökan.",
    "noBidsMessage": "Du har inte fått några erbjudanden på din ansökan.",
    "noBidsImproveApplicationRecommend": "Vi rekommenderar att du gör en ny ansökan om 3 månader. \n Kontakta kundtjänst om du vill ha hjälp med din ansökan.",
    "noBidsStartNewApplication": "Starta en ny ansökan",
    "biddingExpiredNoBids": {
      "title": "Inga erbjudanden har kommit in på din ansökan",
      "description": "Behöver du hjälp? Kontakta vår kundtjänst."
    },
    "bidsReceived": {
      "title": "Du har fått {{bidsCount}} finansieringsförslag.",
      "subtitle": "Den officiella budgivningstiden för din ansökan har löpt ut."
    },
    "noBindingOffersBanner": "Att gå vidare med ett erbjudande är inte bindande. Du kan när som helst ändra ditt val.",
    "selectedBidLabel": "Valt förslag",
    "recommendedBidLabel": "Rekommenderat",
    "paidOutBidLabel": "Utbetalt erbjudande",
    "goodAlternativeBidLabel": "Bra alternativ",
    "promotionTitle": "Kampanj",
    "promotions": {
      "amortisation_free_one": "Första månaden utan amortering",
      "amortisation_free_other": "Första {{count}} månaderna utan amortering",
      "interest_free_one": "Första månaden utan ränta",
      "interest_free_other": "Första {{count}} månaderna utan ränta"
    },
    "creditTerms": "Kreditvillkor",
    "showDetails": "Detaljer",
    "hideDetails": "Göm detaljer",
    "sortOffers": "Sortera förslag",
    "bestOffer": "Bäst erbjudande",
    "sortKeys": {
      "bestOffer": {
        "desc": "Bäst erbjudande"
      },
      "amount": {
        "asc": "Lägst belopp",
        "desc": "Högst belopp"
      },
      "paybackTimeMonths": {
        "asc": "Kortast återbetalningstid",
        "desc": "Längst återbetalningstid"
      },
      "averageMonthlyPayment": {
        "asc": "Lägst månadsbetalning",
        "desc": "Högst månadsbetalning"
      },
      "totalLoanAmount": {
        "asc": "Lägst totalbelopp",
        "desc": "Högst totalbelopp"
      },
      "commissionPercent": {
        "asc": "Lägst provision",
        "desc": "Högst provision"
      },
      "withRegress": {
        "asc": "Utan regress först",
        "desc": "Med regress först"
      },
      "limit": {
        "asc": "Lägst kreditgräns",
        "desc": "Högst kreditgräns"
      },
      "firstMonthInterestRate": {
        "asc": "Lägst första månadens ränta",
        "desc": "Högst första månadens ränta"
      },
      "comparableMonthlyInterestRate": {
        "asc": "Lägst månadsränta",
        "desc": "Högst månadsränta"
      },
      "comparableYearlyInterestRate": {
        "asc": "Lägst årsränta",
        "desc": "Högst årsränta"
      }
    },
    "changeInformationForApplication": {
      "title": "Vill du ändra informationen du lämnat i ansökan?",
      "back": "Tillbaka"
    },
    "closeApplicationAsCustomer": {
      "title": "Vill du stänga din ansökan?",
      "description": "Om du stänger din ansökan nu försvinner dina nuvarande erbjudanden. Du behöver skapa en ny ansökan för att få nya erbjudanden.",
      "buttonText": "Stäng ansökan",
      "confirmation": {
        "title": "Varför vill du stänga ansökan?",
        "selectTitle": "Välj anledning",
        "descriptionPlaceholder": "Beskriv varför du vill stänga ansökan",
        "confirm": "Stäng ansökan"
      }
    },
    "biddingOpenLabel": "Budgivningstid kvar",
    "countdown": {
      "day": "dag",
      "days": "dagar",
      "hour": "timme",
      "hours": "timmar",
      "minute": "minut",
      "minutes": "minuter"
    },
    "offersWillAppearHere": "Här visas dina erbjudanden.",
    "sidebar": {
      "applicationInformation": "Ansökningsinformation",
      "requestedAmount": "Önskat belopp",
      "financingAmount": "Finansieringsbelopp",
      "objectType": "Objekttyp",
      "purpose": "Syfte",
      "repaymentTime": "Löptid",
      "guarantors": "Borgensmän",
      "property": "Fastighet",
      "leasing": "Leasing",
      "unpaid_invoices": "Fakturafinansiering",
      "editApplication": "Redigera ansökan"
    },
    "chooseBidButton": "Gå vidare",
    "chooseBidButtonAfterSelected": "Slutför",
    "chooseBidConfirmation": {
      "title": "Vill du gå vidare med förslag?",
      "additions": {
        "description1": "I nästa steg behöver du lägga till följande information för att få ett avtalsförslag."
      },
      "description1": "Genom att klicka på \"Gå vidare\" informeras kreditgivaren om att du är intresserad av förslaget.",
      "description2": "Du binder dig inte till något i detta steg.",
      "cancel": "Avbryt",
      "continue": "Gå vidare",
      "modal": {
        "title": "Vill du gå vidare med erbjudandet?",
        "proceedingIsNonBinding": "Att gå vidare med ett erbjudande är inte bindande.",
        "nextStep": "Nästa steg:",
        "lenderWillContactYou": "{{lender}} kommer att kontakta dig",
        "provideFinalInformation": "Lämna slutlig information direkt till {{lender}}",
        "provideMissingInformation": "Lämna den saknade informationen för det slutliga kreditbeslutet",
        "proceed": "Gå vidare",
        "contactDetailsSharedWithLender": "Dina kontaktuppgifter som kommer att delas med {{lender}}:",
        "multipleGuarantorsRequired": "Obs. Krav på {{guarantorsNumber}} borgensmän med stabil ekonomi och inkomst"
      }
    },
    "comboOffers": {
      "heading": "Kombinerade erbjudanden",
      "description": "Kombinerade erbjudanden: En skräddarsydd finansieringslösning som kombinerar två eller fler erbjudandetyper (t.ex. företagslån och checkkredit) för att möta olika finansieringsbehov.",
      "totalAmount": "Totalt belopp",
      "upToAmount": "Upp till {{amount}}"
    },
    "loanBids": {
      "heading": "Företagslån",
      "description": "Ett företagslån ger ditt företag tillgång till ett fast lånebelopp som återbetalas över tid med ränta. Det används vanligtvis för investeringar eller för att hantera rörelsekapital.",
      "paybackTimeMonthFormat": "månad",
      "paybackTimeMonthsFormat": "månader",
      "columns": {
        "lender": "Långivare",
        "lenderDescription": "Här ser du vilken långivare som givit låneförslaget",
        "approvedAmount": "Belopp",
        "approvedAmountDescription": "Detta är det belopp du erbjudits att låna av långivaren. Det är vanligt att låneförslaget skiljer sig från det belopp företagare ansökt om. Anledningen är att långivare skickar in förslag på de bästa villkor de kan erbjuda baserat på den information de fått, även om erbjudandet inte motsvarar er ansökan.",
        "repaymentTime": "Återbetalningstid",
        "repaymentTimeDescription": "Återbetalningstid är den tidsperiod låntagaren skall betala tillbaka lånet på.",
        "monthlyCost": "Månadsbetalning",
        "monthlyCostDescription": "Månadsbetalning visar det genomsnittliga beloppet som betalas till långivaren per månad under lånets löptid. Beroende på vilken avbetalningsplan långivaren erbjuder kan storleken på betalningarna variera över månader men i genomsnitt är månadsbetalningarna det som visas i denna kolum.",
        "totalCost": "Total lånekostnad",
        "totalCostDescription": "Total lånekostnad inkluderar alla kostnader och avgifter, men inte det lånade beloppet.",
        "importantInfo": "Fördelar"
      }
    },
    "factoringBids": {
      "heading": "Factoring",
      "description": "Factoring ger ditt företag tillgång till finansiering direkt genom att sälja eller belåna era fakturor, istället för att vänta på att kunderna betalar.",
      "withRegressYes": "Ja",
      "withRegressNo": "Nej",
      "paymentTermsDays": "dagar",
      "columns": {
        "factoringCompany": "Factoringbolag",
        "factoringCompanyDescription": "Här ser du vilka factoringbolag som lämnat erbjudande för fakturaköp",
        "approvedAmount": "Belopp",
        "approvedAmountDescription": "Erbjudet belopp är det belopp du fått offererat att låna av factoringbolaget. Det kan vara mindre än fakturavärdet du ville sälja i fall att factoringbolaget inte vill köpa alla fakturor. Det kan vara fallet att vissa fakturor inte är i linje med de krav som factoringbolaget ställer - till exempel om fakturamottagaren har för låg kreditvärdighet eller om fakturan har för lång förfallotid. Erbjudanden är inte bindande och det är upp till dig att välja om du vill gå vidare med förslaget eller inte.",
        "commissionTime": "Provision per faktura",
        "commissionTimeDescription": "Kostnaden per finansierad faktura som factoringbolaget tar. Denna kostnad avser finansiering, men täcker även tjänster som du får tillgång till (till exempel faktureringstjänst, påminnelser, inkasso, kreditupplysning, osv.).",
        "comparableMonthlyInterest": "Jämförbar månadsränta",
        "comparableMonthlyInterestDescription": "Jämförbar månadsränta visar hur mycket det i genomsnitt kostar i procent per månad att sälja fakturor och inkluderar alla räntor och avgifter. Denna ränta kan skilja sig från provisionen och den ränta som visas i factoringbolagets avtal då de ibland beräknar kostnader på annorlunda vis.",
        "paidOutAmount": "Utbetalt belopp",
        "paidOutAmountDescription": "Utbetalt belopp visar det beloppet som betalas ut med första utbetalningen från factoringbolaget till dig. Utbetalt belopp inkluderar alla provisioner, räntor och avgifter. Moms tillkommer och måste betalas på hela den totala ersättningen för tjänsten, det vill säga mellanskillnaden mellan köpeskillingen och fakturornas nominella värde plus samtliga debiterade avgifter.",
        "regressCost": "Regress",
        "regressCostDescription": "Anger om factoringbolaget har rätten att återkräva betalning från dig om fakturamottagaren ej betalar. Regressrätten brukar vara tidslimiterad, det betyder att factoringbolaget driver in betalning från dina kunder och kräver återbetalning från dig efter ett definierat antal dagar (i fall att dom offerar fakturaköp med regress).",
        "importantInfo": "Fördelar"
      }
    },
    "realEstateBids": {
      "heading": "Fastighetslån",
      "description": "Ett fastighetslån ger ditt företag tillgång till finansiering som kan användas för att köpa, refinansiera eller utveckla en fastighet.",
      "paybackTimeMonthFormat": "månad",
      "paybackTimeMonthsFormat": "månader",
      "columns": {
        "lender": "Långivare",
        "lenderDescription": "Här ser du vilken långivare som givit låneförslaget",
        "amount": "Belopp",
        "approvedAmount": "Belopp",
        "approvedAmountDescription": "Detta är det belopp du erbjudits att låna av långivaren. Det är vanligt att låneförslaget skiljer sig från det belopp företagare ansökt om. Anledningen är att långivare skickar in förslag på de bästa villkor de kan erbjuda baserat på den information de fått, även om erbjudandet inte motsvarar er ansökan.",
        "repaymentTime": "Återbetalningstid",
        "repaymentTimeDescription": "Återbetalningstid är den tidsperiod låntagaren skall betala tillbaka lånet på.",
        "averageMonthlyPayment": "Månadsbetalning",
        "monthlyCost": "Månadsbetalning",
        "monthlyCostDescription": "Månadsbetalning visar det genomsnittliga beloppet som betalas till långivaren per månad under lånets löptid. Beroende på vilken avbetalningsplan långivaren erbjuder kan storleken på betalningarna variera över månader men i genomsnitt är månadsbetalningarna det som visas i denna kolum.",
        "totalCost": "Total lånekostnad",
        "totalCostDescription": "Total lånekostnad inkluderar alla kostnader och avgifter, men inte det lånade beloppet.",
        "importantInfo": "Fördelar"
      }
    },
    "leasingBids": {
      "heading": "Leasing",
      "description": "Leasing ger ditt företag tillgång till utrustning eller tillgångar genom att betala en återkommande avgift över tid, ofta med möjlighet att köpa tillgången senare.",
      "columns": {
        "lender": {
          "title": "Leasingbolag",
          "description": "Här ser du vilka leasingbolag som lämnat förslag för ditt företag"
        },
        "amount": {
          "title": "Belopp",
          "description": "Erbjudet belopp är det belopp du fått offererat av leasingbolaget. Beloppet motsvarar oftast anskaffningskostnaden (exklusive moms) och är det beloppet som leasingbolaget betalar till leverantören. Förslagen är inte bindande och det är upp till dig att välja om du vill gå vidare med förslaget eller inte."
        },
        "repaymentTime": {
          "title": "Leasingperiod",
          "description": "Leasingperiod är den period (antal månader) som leasingavtalet gäller. Efter leasingavtalets slut kan man antingen förlänga avtalet eller köpa ut objektet för angivet restvärde. För hyreskontrakt är det även vanligt att lämna tillbaka hyresobjektet."
        },
        "monthlyPayment": {
          "title": "Månadsbetalning",
          "description": "Månadsbetalning visar det genomsnittliga beloppet som betalas till leasingbolaget per månad under leasingperioden. Beroende på vilket restvärde och storleken av den första förhöjda hyran kan månadsbetalningarna variera. Månadsbetalningarna för Leasing ska alltid vara desamma varje månad fram till leasingperiodens slut."
        },
        "totalCost": {
          "title": "Total leasingkostnad",
          "description": "Total leasingkostnad inkluderar alla kostnader och avgifter, men inte den första förhöjda hyra eller restvärdet som ditt företag kan behöva betala vid leasingperiodens slut."
        },
        "importantInfo": {
          "title": "Fördelar"
        }
      }
    },
    "revolvingCreditBids": {
      "heading": "Checkkredit",
      "description": "En checkkredit ger ditt företag tillgång till en flexibel kreditgräns som ni kan utnyttja vid behov, där ränta vanligtvis endast tas ut på det utnyttjade beloppet.",
      "columns": {
        "lender": {
          "title": "Långivare",
          "description": "Här ser du vilken långivare som givit förslaget."
        },
        "limit": {
          "title": "Limit",
          "description": "Detta är limiten du erbjudits att låna av långivaren. Det är vanligt att förslaget skiljer sig från det belopp företagare ansökt om. Anledningen är att långivare skickar in förslag på de bästa villkor de kan erbjuda baserat på den information de fått, även om erbjudandet inte motsvarar er ansökan."
        },
        "averageMonthlyPayment": {
          "title": "Månadsbetalning",
          "description": "Månadsbetalning visar det genomsnittliga beloppet som betalas till långivaren per månad. För Checkkredit antar vi att krediten används till 50% av limiten i genomsnitt. Storleken på betalningarna varierar över månader."
        },
        "amortisationPerMonth": {
          "title": "Amortering per månad",
          "description": "Vissa checkkredit kan ha ett krav att du amorterar en visst summa per månad. Det går dock att ta upp en större belopp igen under tiden, maximalt upp till limitbeloppet."
        },
        "importantInfo": {
          "title": "Fördelar"
        }
      }
    },
    "purchaseFinancingBids": {
      "heading": "Inköpsfinansiering",
      "description": "Inköpsfinansiering är ett kortfristigt lån som gör det möjligt för ditt företag att köpa varor eller material utan att belasta likviditeten. Finansiären betalar leverantören i förskott, och lånet återbetalas i avbetalningar över tid.",
      "columns": {
        "lender": {
          "title": "Långivare",
          "description": "Här ser du vilken långivare som givit förslaget."
        },
        "amount": {
          "title": "Belopp",
          "description": "Detta är beloppet som långivaren erbjuder att finansiera."
        },
        "averageMonthlyPayment": {
          "title": "Månadsbetalning",
          "description": "Månadsbetalning visar det genomsnittliga beloppet som betalas till långivaren per månad."
        },
        "importantInfo": {
          "title": "Fördelar"
        }
      }
    },
    "commonBidsColumns": {
      "comparableYearlyInterestRate": {
        "title": "Effektiv årsränta",
        "description": "Effektiv årsränta visar hur mycket det i genomsnitt kostar i procent per år i räntor och avgifter. Denna ränta kan skilja sig något från räntan som visas i långivarens avtal då de ibland beräknar kostnader på annorlunda vis."
      },
      "comparableMonthlyInterestRate": {
        "title": "Effektiv månadsränta",
        "description": "Effektiv månadsränta visar hur mycket det i genomsnitt kostar i procent per månad i räntor och avgifter. Denna ränta kan skilja sig från räntan som visas i långivarens avtal då de ibland beräknar kostnader på annorlunda vis."
      },
      "firstMonthInterestRate": {
        "title": "Ränta, första månad",
        "description": "Ränta, första månad visar hur mycket ränta du betalar i procent under antagandet att du återbetalar lånet efter 30 dagar. Kostnaden inkluderar inga eventuella extra avgifter och räntekostnaden kan variera över avtalets löptid."
      },
      "details": "Detaljer"
    },
    "bidsRateToaster": {
      "text": "Dina förslag visas med",
      "comparableYearlyInterestRate": {
        "selected": "effektiva årsräntan",
        "showText": "Visa effektiv årsränta"
      },
      "comparableMonthlyInterestRate": {
        "selected": "effektiva månadsräntan",
        "showText": "Visa effektiv månadsränta"
      },
      "firstMonthInterestRate": {
        "selected": "räntan för första månaden",
        "showText": "Visa ränta, första månad"
      }
    },
    "chooseOtherBid": {
      "text": "Om du vill ändra dig eller undrar något, kontakta kundservice.",
      "cancelButton": "Avbryt",
      "confirmButton": "Kontakta kundservice"
    },
    "createdState": {
      "heading": "Din ansökan har inte skickats in ännu"
    },
    "rejectedState": {
      "heading": "Din ansökan har inte skickats in"
    },
    "bidsRejected": {
      "heading": "Vi har noterat att du har avvisat nya erbjudanden för denna ansökan.",
      "paragraphWithLinktoSupport": "Om detta inte verkar rätt <1>kontakta kundtjänst</1>"
    },
    "importantInfo": {
      "euLoanBidDetailsHeading": "Företagslån med EU-stöd",
      "euLoanBidDetailsText": "Detta låneförslag har stöd av EU, där villkoren blir mer fördelaktiga. Lånet har lägre ränta och ett begränsat borgensåtagande om endast 20 % av lånebeloppet. Anledningen är att lånet omfattas av en garanti som finansieras av Europeiska Unionen inom programmet för sysselsättning och social innovation (EaSI)."
    },
    "messages": {
      "applicationNotSubmitted": {
        "title": "Din ansökan har inte skickats in automatiskt.",
        "subtitle": "Vår kundtjänst hör av sig till dig.",
        "reason": "Vad kan det bero på?",
        "description": "Det kan bero på att du inte är firmatecknare på angivet företag eller att du har en tidigare ansökan som fortfarande inte är avslutad. Vår kundtjänst hör av sig till dig inom en arbetsdag",
        "duplicate": {
          "title": "Du har en tidigare ansökan som ännu inte avslutats.",
          "subtitle": "Välj nedan hur du vill gå vidare.",
          "readMoreText": "Läs mer",
          "readMoreModalText": "Erbjudanden från långivare på din tidigare ansökan är giltiga i minst 30 dagar. Vi rekommenderar att du fortsätter med den tidigare ansökan om du fortfarande har aktiva erbjudanden.",
          "continueWithApplication": {
            "title": "Fortsätt med tidigare ansökan",
            "description": "Ansökan skapades den {{creationDate}} och har {{noActiveOffers}} aktiva erbjudanden",
            "actionText": "Fortsätt med tidigare ansökan"
          },
          "submitNewApplication": {
            "title": "Skicka in ny ansökan och avsluta tidigare ansökan",
            "description": "Genom att skicka in avslutar vi din tidigare ansökan. Du kommer inte att ha tillgång till detaljer eller erbjudanden från den tidigare ansökan.",
            "actionText": "Skicka in ny ansökan"
          }
        },
        "noSigningRights": {
          "title": "Vi kunde inte automatiskt verifiera din koppling till detta företag i offentliga register.",
          "subtitle": "Beskriv din koppling till företaget nedan.",
          "submitExplanationButton": "Skicka",
          "explanationSubmitted": "Vi har tagit emot din beskrivning. Vår kundtjänst kommer att kontakta dig."
        }
      },
      "rejectedByKrea": {
        "description": "Det kan bero på att ditt företag inte är registrerat än eller att du har en tidigare ansökan som fortfarande inte är avslutad."
      },
      "applicationAdvice": {
        "title": "Vi har märkt att liknande företag får bättre erbjudanden om någon av våra rådgivare hjälper dem.",
        "subtitle": "Om du vill få råd kommer en av våra rådgivare att kontakta dig inom en arbetsdag."
      },
      "applicationSimpleManualAdvice": {
        "title": "Vill du gå vidare utan att prata med din rådgivare först?",
        "subtitle": "Du kan skicka in utan att ha ett telefonsamtal först, men tänk på att det kan leda till sämre erbjudanden."
      },
      "applicationAdviceWaiting": {
        "title": "Din rådgivare kommer att kontakta dig inom en arbetsdag."
      },
      "applicationDigitalAdvice": {
        "title": "Vi har hittat möjliga förbättringar på din ansökan.",
        "subtitle": "Förbättra din ansökan genom att följa våra rekommendationer.",
        "subtitleAdvicePage": "Dessa förbättringar kan leda till bättre erbjudanden."
      }
    }
  },
  "bidType": {
    "COMPANY_LOAN": "Företagslån",
    "FACTORING": "Factoring",
    "LEASING": "Leasing",
    "REAL_ESTATE": "Fastighetslån",
    "REVOLVING_CREDIT": "Checkkredit",
    "PURCHASE_FINANCING": "Inköpsfinansiering"
  },
  "bidDetails": {
    "show": "Visa detaljer på valt förslag",
    "repaymentTime": "Återbetalningstid",
    "contractInterestMonthly": "Månadsränta eller månadsavgift som kommer stå i kontrakt",
    "contractInterestYearly": "Årsränta som kommer stå i kontrakt",
    "amortisation": "Amorteringstyp",
    "totalCost": "Total kostnad (räntekostnader och övriga avgifter)",
    "averageMonthlyPayment": "Genomsnittlig månadsbetalning (amortering och ränta)",
    "averageMonthlyCost": "Genomsnittlig månadskostnad (räntor och avgifter)",
    "firstMonthCost": "Kostnad första månaden (räntor och avgifter)",
    "firstMonthRate": "Första månadens ränta",
    "monthlyRate": "Månadsränta",
    "yearlyRate": "Årsränta",
    "earlyRepaymentFee": "Kostnad för förtidsinlösen",
    "repayableWithoutFee": "Kostnadsfri",
    "setupFee": "Uppsättningskostnad",
    "postalFee": "Avi-avgift (per månad)",
    "directDebitFee": "Avgift för autogiro (per månad)",
    "totalCostExplainer": "Alla avgifter är inkluderade i total kostnad",
    "oneTimeFee": "engångskostnad",
    "daily": "per dag",
    "weekly": "per vecka",
    "monthly": "per månad",
    "quarterly": "per kvartal",
    "yearly": "per år",
    "benefits": "Fördelar",
    "importantCollateral": "Säkerheter",
    "additionalInformation": "Nödvändig information för slutligt kreditbeslut:",
    "moreAbout": "Mer om: ",
    "registeredByFI": "Godkänd av Finansinspektionen",
    "paidOutShow": "Visa detaljer på din finansiering",
    "paidOutStartNew": "Påbörja en annan ansökan",
    "collectedByLenderFieldRequestInfo": "Hämtas automatiskt med BankID - tar endast 2-3 minuter",
    "lenderComment": "Långivarens kommentar: ",
    "alreadySubmitted": "Redan inskickad",
    "submitInNextStep": "Skicka in i nästa steg",
    "submitToLenderSite": "Skicka in hos långivaren",
    "keyCalculations": "Nyckeltal för ditt erbjudande",
    "lender": "Långivare",
    "principalRepayment": "Amortering",
    "interestPayment": "Räntekostnad",
    "monthlyPayment": "Genomsnittlig månadsbetalning",
    "firstMonthAmortisation": "Första månadens amortering",
    "firstMonthPayment": "Första månadens betalning",
    "principalRepaymentPerMonth": "Amortering (per månad)",
    "interestPaymentPerMonth": "Räntekostnad (per månad)",
    "monthlyPaymentPerMonth": "Månadsbetalning (per månad)",
    "costPerMonth": "Kostnad (per månad)",
    "amount": "Belopp",
    "fixedMonthlyFee": "Fast månadsavgift"
  },
  "realEstateBidDetails": {
    "repaymentTimeMonths": "Löptid"
  },
  "factoringBidDetails": {
    "show": "Visa detaljer på valt förslag",
    "purchasedAmountPercent": "Finansieringsgrad (i %)",
    "purchaseLimit": "Fakturaköpslimit",
    "limitFeePerYearPercent": "Limitavgift (per år)",
    "setupFee": "Uppsättningskostnad",
    "handlingFeePerInvoice": "Hanteringsavgift per faktura (utan portokostnad)",
    "monthlyFee": "Fast månadsavgift",
    "totalMonthlyCost": "Månadskostnad",
    "regressNumDaysAfterDueDate": "Regress antal dagar",
    "regressDaysFormat": "dagar",
    "totalCostExplainer": "Alla avgifter är inkluderade i total lånekostnad",
    "monthly": "per månad"
  },
  "leasingBidDetails": {
    "downPayment": "Första förhöjd hyra",
    "terminalValue": {
      "title": "Restvärde",
      "description": "Restvärde gäller enbart för finansiell leasing (dvs. inte hyra). Det beskriver det förväntade marknadsvärdet på leasingobjektet vid slutet av leasingperioden. Efter leasingavtalets slut har du möjlighet att köpa loss leasingobjektet genom att betala restvärdet till leasingbolaget."
    },
    "setupFee": "Uppsättningskostnad",
    "totalCost": "Total leasingkostnad",
    "totalCostExplainer": "Alla ovan angivna avgifter är inkluderade i totalkostnaden",
    "typeOfContract": {
      "title": "Typ av kontrakt",
      "type": {
        "leasing": {
          "title": "Leasing",
          "description": "Företagsleasing är bra för företag som vill investera i ny eller begagnad utrustning, maskiner eller inredning utan att behöva köpa eller låna. När avtalet löpt ut kan du förlänga avtalet, köpa objektet till ett restvärde eller lämna tillbaka objektet."
        },
        "rent": {
          "title": "Hyra",
          "description": "Ibland lämpar det sig bättre att hyra istället för att leasa. Framför allt vid de tillfällen då du vill kunna byta ut utrustningen under avtalsperioden. När avtalet löper ut kan du förlänga hyresperioden eller lämna tillbaka objektet."
        }
      }
    },
    "postalFee": "Avi-avgift (är inte inkluderad i månadsbetalningen)",
    "insuranceCostPerMonth": "Försäkringskostnad per månad (är inte inkluderad i månadsbetalningen)"
  },
  "revolvingCreditBidDetails": {
    "amount": "Kreditlimit",
    "monthlyInterestRate": "Ränta (per månad)",
    "monthlyAmortisation": "Amortering per månad",
    "setupFee": "Uppsättningskostnad",
    "postalFee": "Avi-avgift",
    "withdrawalFee": {
      "title": "Uttagsavgift",
      "description": "Uttagsavgiften betalas vid varje tillfälle där du vill dra ner ytterliga pengar från din finansieringslimit."
    },
    "limitFeePerYear": "Limitavgift per år"
  },
  "revolvingCreditBidDetais": {
    "monthlyInterestRate": "Månadsränta eller månadsavgift som kommer stå i kontrakt",
    "lenderMonthlyInterest": "Månadsränta",
    "averageMonthlyPayment": {
      "title": "Månadsbetalning",
      "description": "Baserat på antagandet att Checkkrediten används till 50% av limiten i genomsnitt. Storleken på betalningarna varierar över månader"
    },
    "averageMonthlyCost": {
      "title": "Genomsnittlig månadskostnad (räntor och avgifter)",
      "description": "Baserat på antagandet att Checkkrediten används till 50% av limiten i genomsnitt. Storleken på kostnader varierar över månader"
    },
    "setupFee": "Uppsättningskostnad",
    "postalFee": "Avi-avgift",
    "withdrawalFee": {
      "title": "Uttagsavgift",
      "description": "Uttagsavgiften betalas vid varje tillfälle där du vill dra ner ytterliga pengar från din finansieringslimit."
    },
    "limitFeePerYear": "Limitavgift per år"
  },
  "recommendedSelect": {
    "toast": {
      "heading": "Du har fått ett bra preliminärt förslag från {{lenderCompanyName}}",
      "subheading": "Detta erbjudande verkar passa din situation bäst. Slutför ansökningsprocessen för att få finansieringen utbetald."
    },
    "proceedWithAnotherOfferToast": {
      "heading": "Vill du gå vidare med ett annat förslag?",
      "subheading": "Gör ditt val nedan."
    }
  },
  "postSelect": {
    "heading": {
      "default": "Lägg till information",
      "withLenderSigningUrl": "Slutför ansökan med {{lenderCompanyName}}",
      "withoutLenderSigningUrl": "{{lenderCompanyName}} kommer att kontakta dig"
    },
    "toast": {
      "requiredInformation": "Lämna den önskade informationen för att få finansieringen utbetald",
      "withLinkToLender": {
        "title": "Långivaren kräver att du slutför ansökan på deras hemsida.",
        "buttonText": "Få utbetalt hos långivaren"
      },
      "withoutLinkToLender": {
        "title": "Du har lagt till den information som behövs.",
        "subtitle": "Långivaren kommer att gå igenom din ansökan och kontaktar dig inom kort."
      }
    },
    "productDetails": {
      "title": "Detaljer",
      "companyLoan": "Lånedetaljer",
      "factoring": "Fakturaköpsdetaljer",
      "leasing": "Leasingdetaljer",
      "realEstate": "Fastighetsdetaljer",
      "revolvingCredit": "Detaljer om kontokredit"
    },
    "lenderComment": "Kommentar från långivare",
    "isCollectedByLender": "Information som hämtas av långivaren i nästa steg",
    "customerContactInfo": {
      "heading": "Kontaktinformation till",
      "phone": "Telefonnummer",
      "email": "E-post"
    },
    "actions": {
      "nextStepCta": "Slutför och få din utbetalning",
      "goToDashboard": {
        "title": "Vill du se alla förslag igen?",
        "titleEligibleForPaymentNoLink": "Vill du se alla erbjudanden och fortsätta med en annan långivare istället?",
        "titleEligibleForPaymentWithLink": "Vill du se alla erbjudanden igen?",
        "buttonText": "Tillbaka"
      },
      "createNewApplication": {
        "title": "Vill du skapa en ny ansökan?",
        "buttonText": "Skapa ny ansökan"
      }
    },
    "lastStep": "Sista steget:",
    "onboardAndProvideInformation": "Fyll i den sista informationen på {{lenderCompanyName}} webbplats för att få utbetalt.",
    "allInformationProvided": "Du har lämnat all nödvändig information",
    "lenderWillReviewYourApplication": "Långivaren kommer att granska din ansökan och återkomma till dig inom kort.",
    "faq": {
      "processSteps": {
        "title": "Hur ser processen ut att få finansiering utbetalt?",
        "list": {
          "withLinkToLender": {
            "step1": "Gå vidare till långivaren för att slutföra din ansökan: <a>Fortsätt på långivarens webbplats</a>",
            "step2": "Långivaren går igenom dina uppgifter och kan be om kompletterande uppgifter",
            "step3": "Långivaren skickar avtalet för signering och betalar ut finansieringen"
          },
          "withoutLinkToLender": {
            "step1": "Långivaren går igenom din ansökan",
            "step2": "De kan be om kompletterande uppgifter",
            "step3": "Långivaren skickar avtalet för signering och betalar ut finansieringen"
          }
        }
      },
      "explanation": {
        "title": "Hur lång tid tar det innan finansieringen blir utbetald?",
        "text": "Den genomsnittliga tiden från ansökan till utbetalning hos Krea är ungefär 3-10 dagar. För mindre krediter är det även vanligt att få utbetalning samma dag eller inom 1-3 arbetsdagar."
      }
    },
    "paidOut": {
      "title": "Tack för att du har använt vår tjänst",
      "subtitle": "Enligt våra uppgifter har du fått din finansiering utbetalt"
    }
  },
  "bidSelected": {},
  "factoringBidSelected": {},
  "realEstateBidSelected": {},
  "delegateFieldRequest": {
    "inviteHeading": "Ange e-post till personen du vill bjuda in att lägga till informationen.",
    "personsWithAccessTitle": "Personer som har tillgång till denna fråga:",
    "revokeAccess": "Radera",
    "revokeAccessTooltip": "Tar bort den här personens åtkomst till frågan",
    "ctaButton": "Skicka länk till e-post",
    "validation": {
      "invalidEmail": "Ange en giltig e-post."
    },
    "uploadLater": {
      "heading": "Skicka en länk till min e-post så att jag kan fortsätta senare",
      "ctaButton": "Skicka länk till min e-post",
      "linkWillBeSent": "Vi skickar en länk för att ladda upp bokföringsdata till den e-postadress du angav.",
      "helperPrompt": "Har du inte uppgifterna nu? <trigger>Skicka ett mejl till dig själv för att ladda upp senare</trigger>",
      "modalTitle": "Ladda upp senare"
    }
  },
  "footer": {
    "heading": "Kontakta oss",
    "phoneLabel": "Telefon:",
    "emailLabel": "E-post:",
    "addressLabel": "Adress:",
    "openingHours": "Öppettider kundservice",
    "mondayToThursdayLabel": {
      "SE": "Måndag - Torsdag",
      "FI": "Måndag - Fredag"
    },
    "fridayLabel": "Fredag"
  },
  "cookieConsentThirdPartyApp": {
    "consent_modal": {
      "description": "Vi använder cookies för att få våran tjänst att fungera samt för att förbättra din upplevelse. Vi delar också data med våra annonspartners.",
      "secondary_btn": {
        "text": "Hantera cookies",
        "role": "settings"
      },
      "primary_btn": {
        "text": "Tillåt alla",
        "role": "accept_all"
      }
    },
    "settings_modal": {
      "title": "Inställningar för cookies",
      "save_settings_btn": "Spara inställningar",
      "accept_all_btn": "Tillåt alla",
      "close_btn_label": "Close",
      "blocks": [
        {
          "description": "Vi använder cookies för att säkerställa de grundläggande funktionerna i vår tjänst och för att förbättra din upplevelse. Du kan själv ställa in vilka cookies som ska sparas på vår webbplats genom att välja vilka kategorier av cookies som du godkänner."
        },
        {
          "title": "Nödvändiga",
          "description": "Dessa cookies är nödvändiga för att vår webbplats ska fungera korrekt. Utan dessa cookies skulle webbplatsen inte fungera korrekt och därför kan de inte stängas av.",
          "toggle": {
            "value": "necessary",
            "enabled": true,
            "readonly": true
          }
        },
        {
          "title": "Statistik",
          "description": "Dessa cookies sparar information om hur vår webbplats används och ger oss möjligheter att förbättra våra produkter.",
          "toggle": {
            "value": "analytics_storage",
            "enabled": false,
            "readonly": false
          }
        },
        {
          "title": "Marknadsföring och Personalisering",
          "description": "Dessa cookies används för att förbättra din upplevelse på vår webbplats och för marknadsföringsändamål. Genom att dela denna information med våra marknadsföringspartners, såsom Google och Microsoft, kan vi visa mer relevant information och annonser för dig. De hjälper oss även att skapa en mer personlig upplevelse genom att analysera din interaktion med vår webbplats, vilket gör det möjligt för oss att personalisera innehållet och erbjudandena till dina preferenser och intressen.",
          "toggle": {
            "value": "ad_storage",
            "enabled": false,
            "readonly": false
          }
        }
      ]
    }
  },
  "remoteIdentification": {
    "factoringLabel": "Fakturaköp",
    "leasingLabel": "Leasing för",
    "reasonLabelSMS": "Syfte",
    "ssnLabelSMS": "Ange personnummer",
    "SMSIdentifyKrea": "Identifiera dig hos Krea",
    "SMSIdentifyKredita": "Identifiera dig hos Kredita",
    "toastText": "Du identifierar dig hos oss så att vi kan säkerställa att du är firmatecknare för",
    "identifyYourself": "Identifiera dig",
    "customerView": "Kundvy",
    "product": "Produkt",
    "copyShareableLink": "Kopiera länk",
    "copiedLink": "Kopierat!",
    "linkExpires": "Länken upphör att gälla: {{expiryDate}}",
    "fraudClientErrorPage": {
      "title": "Ansökan kunde inte skapas.",
      "description": "Du har blockerats från att skapa nya ansökningar.",
      "descriptionNewLine": "Om du inte är medveten om detta eller tror att detta kan vara felaktigt, vänligen kontakta oss."
    },
    "genericErrorPage": {
      "title": "Något gick fel.",
      "description": "Vänligen försök igen eller kontakta kundtjänst."
    }
  },
  "reviewProvider": {
    "google": {
      "numberOfReviews": "{{numberOfReviews}} recensioner"
    },
    "reviews": "omdömen",
    "trustpilotWidget": {
      "grade": "Utmärkt"
    },
    "officialFinancingPartner": "Exklusiv finansieringspartner",
    "trustMessage": "{{company}} har hjälpt över {{businessCount}} företag att hitta den bästa finansieringen"
  },
  "applicationProgress": {
    "title": "Ansökningsprocess",
    "tabs": {
      "progress": "Förlopp",
      "aiAssistant": "AI-assistent"
    },
    "step1": {
      "label": "Kontaktuppgifter"
    },
    "step2": {
      "label": "Finansieringsbehov & identifiering",
      "substep1": "Syfte",
      "substep2": {
        "default": "Belopp",
        "objectFinancing": "Köp-/leasingbehov",
        "invoiceFinancing": "Fakturainformation",
        "realEstate": "Fastighetsinformation"
      },
      "substep3": "Identifiering"
    },
    "step3": {
      "label": "Viktig information",
      "sidebarLabels": {
        "reason_explanation": "Beskriv ditt behov",
        "grouped_real_estate_repayment": "Återbetalningsplan",
        "self_estimated_historic_revenue": "Uppskattad omsättning"
      }
    },
    "step4": {
      "label": "Skicka & få erbjudanden"
    },
    "postSubmitTitle": "Få erbjudanden & ta emot finansiering",
    "substep": {
      "skipped": "Hoppade över"
    },
    "collapse": "Dölj",
    "expand": "Visa",
    "stepXofY": "Steg {{current}} av {{total}}",
    "resizeSidebar": "Ändra sidofältets bredd",
    "completed": "Klar",
    "completedStepTooltip": "Du kan redigera denna information precis innan du skickar in",
    "editApplication": "Redigera din ansökan",
    "editApplicationPartner": "Redigera kundens ansökan"
  },
  "postSubmitProgress": {
    "step1": {
      "label": "Ansökan"
    },
    "step2": {
      "label": "Erbjudanden",
      "tooltip": {
        "locked": "Tillgängligt när ansökan har skickats till långivarna"
      }
    },
    "step3": {
      "label": "Valt erbjudande",
      "tooltip": {
        "locked": "Tillgängligt när du valt ett erbjudande"
      }
    },
    "verification": {
      "label": "Verifiering av {{company}}"
    },
    "improveApplication": {
      "label": "Förbättra ansökan"
    },
    "advice": {
      "label": "Rådgivning"
    }
  },
  "leaveReview": {
    "heading": "Nöjd med {{company}}?",
    "subtext": "Dela din upplevelse och hjälp andra att hitta rätt finansiering.",
    "reviews": "omdömen",
    "google": {
      "cta": "Lämna ett Google-omdöme"
    },
    "trustpilot": {
      "cta": "Lämna ett Trustpilot-omdöme"
    }
  },
  "triageFields": {
    "toastTexts": {
      "reasonExplanation": {
        "title": "Innan du skickar in ansökan",
        "subtitle": "Vi identifierade {{numberOfQuestions}} valfria frågor som kan leda till bättre erbjudanden"
      },
      "refinancingAmounts": {
        "title": "Du har valt ett syfte relaterad till refinansiering.",
        "subtitle": "Om ditt företag vill återbetala befintliga skulder, besvara nedan information."
      },
      "leasingAdditionalData": {
        "title": "Fyll i nedan så får du även leasingförslag",
        "subtitle": "Leasing kan vara ett smidigt sätt att finansiera fordon eller utrustning utan att binda mycket kapital direkt. Hoppar du över får du fortfarande erbjudanden om företagslån."
      },
      "guarantors": {
        "title": "Företag som anger minst en borgensman är 3 gånger mer sannolika att få ett lån utbetalt.",
        "subtitle": ""
      }
    }
  },
  "mobileMenu": {
    "title": "Meny",
    "language": "Språk",
    "partnerRole": "Partner"
  }
}
